import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ChangeEvent, CKEditorModule } from '@ckeditor/ckeditor5-angular';
import DOMPurify from 'dompurify';
import { NavigationService } from 'src/app/services/navigation.service';

import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from 'angular-svg-icon';
import {
	AccessibilityHelp,
	AutoLink,
	Autosave,
	BlockQuote,
	Bold,
	ClassicEditor,
	Code,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	Heading,
	Highlight,
	Italic,
	Link,
	List,
	Paragraph,
	SelectAll,
	SpecialCharacters,
	SpecialCharactersArrows,
	SpecialCharactersCurrency,
	SpecialCharactersEssentials,
	SpecialCharactersLatin,
	SpecialCharactersMathematical,
	SpecialCharactersText,
	Strikethrough,
	Subscript,
	Superscript,
	Underline,
	Undo,
	type EditorConfig
} from 'ckeditor5';
import { ProfileImageModule } from 'snl-complib';
import { Toasts } from 'src/app/constant/toast.messages';
import { AuthService } from 'src/app/services/auth.service';
import { CcdService } from 'src/app/services/ccd.service';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
	selector: 'app-notes',
	standalone: true,
	imports: [CommonModule, CKEditorModule, SvgIconComponent, ProfileImageModule, FormsModule],
	templateUrl: './notes.component.html',
	styleUrls: ['./notes.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class NotesComponent {
	navigationUrl: any = '';
	lastUpdateDate: any;
	public collapsedToggle: boolean = false;
	@Input() from: string = '';

	constructor(
		private readonly router: Router,
		public authService: AuthService,
		public ccdService: CcdService,
		private readonly toasterService: ToasterService,
		public navigationService: NavigationService,
		private readonly changeDetector: ChangeDetectorRef,
		private readonly sanitizer: DomSanitizer
	) {
		let startTime = new Date();
		this.lastUpdateDate = new Date(
			startTime.getTime() + startTime.getTimezoneOffset() * 60000
		);
	}

	@Input() selectedTab: string = '';
	@Input() accessOfNotesEditor: boolean = false;
	@Input() ccdNo: string | null = null;
	public notesLegendStatus: string = 'no_notes' //no_notes, notes_added
	public currentUser: any = [];
	public fetchCcdNotesLoading: boolean = false;
	public createCcdNotesLoading: boolean = false;
	public ccdNotes: any = [];
	public data: any;
	public editor: any;
	public isLayoutReady = false;
	public Editor = ClassicEditor;
	public config: EditorConfig = {}; // CKEditor needs the DOM tree before calculating the configuration.
	public isEditorFocused: boolean = false;

	ngOnInit(): void {
		this.getNotesLegendStatus();
		this.fetchCcdNotes();
		this.populateNotes();
		this.authService.getBackendUserData().subscribe((data: any) => {
			if (data) {
				this.currentUser = data;
			}
		});
	}
	public ngAfterViewInit(): void {
		this.config = {
			toolbar: {
				items: [
					'bold',
					'italic',
					'underline',
					'strikethrough',
					// 'undo',
					// 'redo',
					'|',
					'bulletedList',
					'numberedList',
					'|',
					'highlight',
					// 'fontSize',
					// 'fontFamily',
					'fontColor',
					// 'heading',
					// '|',
					// 'blockQuote',
					// 'link',
					// 'subscript',
					// 'superscript',
					// 'code',
					// 'specialCharacters',

				],
				shouldNotGroupWhenFull: false
			},
			plugins: [
				AccessibilityHelp,
				AutoLink,
				Autosave,
				BlockQuote,
				Bold,
				Code,
				Essentials,
				FontBackgroundColor,
				FontColor,
				FontFamily,
				FontSize,
				Heading,
				Highlight,
				Italic,
				Link,
				List,
				Paragraph,
				SelectAll,
				SpecialCharacters,
				SpecialCharactersArrows,
				SpecialCharactersCurrency,
				SpecialCharactersEssentials,
				SpecialCharactersLatin,
				SpecialCharactersMathematical,
				SpecialCharactersText,
				Strikethrough,
				Subscript,
				Superscript,
				Underline,
				Undo
			],
			fontFamily: {
				supportAllValues: true
			},
			fontSize: {
				options: [10, 12, 14, 'default', 18, 20, 22],
				supportAllValues: true
			},
			// heading: {
			// 	options: [
			// 		{
			// 			model: 'paragraph',
			// 			title: 'Paragraph',
			// 			class: 'ck-heading_paragraph'
			// 		},
			// 		{
			// 			model: 'heading1',
			// 			view: 'h1',
			// 			title: 'Heading 1',
			// 			class: 'ck-heading_heading1'
			// 		},
			// 		{
			// 			model: 'heading2',
			// 			view: 'h2',
			// 			title: 'Heading 2',
			// 			class: 'ck-heading_heading2'
			// 		},
			// 		{
			// 			model: 'heading3',
			// 			view: 'h3',
			// 			title: 'Heading 3',
			// 			class: 'ck-heading_heading3'
			// 		},
			// 		{
			// 			model: 'heading4',
			// 			view: 'h4',
			// 			title: 'Heading 4',
			// 			class: 'ck-heading_heading4'
			// 		},
			// 		{
			// 			model: 'heading5',
			// 			view: 'h5',
			// 			title: 'Heading 5',
			// 			class: 'ck-heading_heading5'
			// 		},
			// 		{
			// 			model: 'heading6',
			// 			view: 'h6',
			// 			title: 'Heading 6',
			// 			class: 'ck-heading_heading6'
			// 		}
			// 	]
			// },
			initialData:
				'',
			// link: {
			// 	addTargetToExternalLinks: true,
			// 	defaultProtocol: 'https://',
			// 	decorators: {
			// 		toggleDownloadable: {
			// 			mode: 'manual',
			// 			label: 'Downloadable',
			// 			attributes: {
			// 				download: 'file'
			// 			}
			// 		}
			// 	}
			// },
			placeholder: 'Enter notes ...'
		};

		this.isLayoutReady = true;
		this.changeDetector.detectChanges();
	}

	populateNotes() {
		this.data = this.ccdService.enteredNote;
	}
	scrollToBottom(): void {
		setTimeout(() => {
			const chatClass = this.from === 'review' ? 'reviewChatMsg' : 'notesPopupChatMsg';
			const chatContainer = document.querySelector('.' + chatClass);
			if (chatContainer) {
				chatContainer.scrollTop = chatContainer.scrollHeight;
			}
		}, 10);
	}


	getNotesLegendStatus() {
		this.ccdService.getDepartmentSpecificNotesLegend().subscribe((event) => {
			this.notesLegendStatus = event?.notesLegendStatus;
		})
	}

	fetchUserInitials(name: string) {
		if (!name) {
			return '';
		}
		if (!name.includes('(') || !name.includes(')')) {
			return name.trim().slice(0, 3);
		}
		return name.substring(name.indexOf('(') + 1, name.indexOf(')')).trim();
	}
	fetchUserName(name: string) {
		if (!name) {
			return '';
		}
		if (!name.includes('(')) {
			return name.trim();
		}
		return name.substring(0, name.indexOf('(')).trim();
	}

	getFormattedDateTime(input: Date) {
		const date = new Date(input);
		const day = String(date.getDate()).padStart(2, '0'); // Day of the month
		const month = date.toLocaleString('default', { month: 'short' }); // Short month name
		const year = date.getFullYear(); // Year
		const hours = date.getHours(); // Hours in 24-hour format
		const minutes = String(date.getMinutes()).padStart(2, '0'); // Minutes

		const formattedDate = `${day} ${month} ${year} - ${hours}:${minutes}`;
		return formattedDate;
	}

	// Use DOMPurify to sanitize input before passing it to Angular's sanitizer
	saferHtml(notes: string) {
		// Sanitize HTML using DOMPurify to remove dangerous content
		const sanitizedContent = DOMPurify.sanitize(notes);  // sanitize is a method of the default export
		return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
	}

	public checkChanges({ editor }: ChangeEvent) {
		this.editor = editor;
		this.data = editor.getData();
		this.ccdService.enteredNote = editor.getData();
	}

	fetchCcdNotes() {
		this.fetchCcdNotesLoading = true;
		this.ccdService.fetchCcdNotes({ ccdNo: this.ccdNo, department: this.selectedTab }).subscribe({
			next: ({ notes }: any) => {
				this.ccdNotes = notes;
				this.scrollToBottom();
				this.fetchCcdNotesLoading = false;
			},
			error: (err: any) => {
				this.fetchCcdNotesLoading = false;
				this.toasterService.openToastCcd(Toasts.Types.Error, Toasts.Actions.GeneralError.Error, Toasts.Actions.GeneralError.Title);
			}
		});
	}

	public addNotes() {
		if (this.data) {
			const noteObj = {
				"department": this.selectedTab,
				"notes": this.data,
				"userName": this.currentUser?.name,
				"createdAt": new Date()
			}
			this.ccdNotes.push(noteObj);
			this.createNotes(this.data, noteObj?.createdAt);
			this.data = '';
			this.editor.setData('');
			this.scrollToBottom();
		}
	}

	createNotes(note: string, createdAt: Date) {
		const notesObj = {
			ccdNo: this.ccdNo,
			department: this.selectedTab,
			notes: note
		}
		this.createCcdNotesLoading = true;
		this.ccdService.setReviewScreenAutoSaveMessage('saving');
		this.ccdService.createNotes({ notesObj: notesObj }).subscribe({
			next: ({ notes }: any) => {
				this.updateLegendStatus();
				this.createCcdNotesLoading = false;
				this.ccdService.setReviewScreenAutoSaveMessage('saved');
				this.ccdService.enteredNote = '';
			},
			error: (error: any) => {
				this.createCcdNotesLoading = false;
				this.ccdService.setReviewScreenAutoSaveMessage('not-saved');
				this.ccdNotes = this.ccdNotes.filter((item: any) => item?.createdAt !== createdAt);
				if (error?.status === 424) {
					this.toasterService.openToastCcd(Toasts.Types.Error, error?.error?.reason);
				}
				else {
					this.toasterService.openToastCcd(Toasts.Types.Error, Toasts.Actions.GeneralError.Error, Toasts.Actions.GeneralError.Title);
				}
			}
		});
	}

	updateLegendStatus() {
		if (this.notesLegendStatus === 'no_notes') {
			this.notesLegendStatus = 'notes_added';
			const reqObj = {
				ccdNo: this.ccdNo,
				action: "NOTES",
				department: this.selectedTab,
			};
			this.ccdService.updateLegend(reqObj).subscribe({
				next: () => {
					this.ccdService.setUpdatedNotesLegend({ department: this.selectedTab });
				},
				error: (err: any) => {
					console.error('Error updating Notes legend:', err);
				}
			});
		}
	}

	toggleClick() {
		this.collapsedToggle = !this.collapsedToggle;
	}

	onReady(editor: any) {
		editor.editing.view.document.on('change:isFocused', (evt: any, data: any, isFocused: any) => {
			this.isEditorFocused = isFocused;
			this.changeDetector.detectChanges();
		});
	}
}

